import React from 'react'
import context from '@/context'
import { DataLoader } from '@/components/dataLoader'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ModalBody } from 'reactstrap'
import { CloseFooter } from '@/dialogs/common/closeFooter'
import LoadingIndicator from '@/components/LoadingIndicator'
import { TabNavItems, TabContent, TabPane } from '@/components/tabs'

const DialogBody = ({ loading, data }) => {
  const [activeTab, setActiveTab] = React.useState('ar')

  if (loading) { return <LoadingIndicator /> }
  return (
    <React.Fragment>
      <TabNavItems activeTabId={activeTab} onClick={setActiveTab} items={[
        { id: 'ar', text: 'Common.Arabic' },
        { id: 'en', text: 'Common.English' }
      ]} />
      <div style={{ overflow: 'auto', maxHeight: '400px' }}>
        <TabContent activeTab={activeTab}>
          <TabPane tabId='ar'><span dangerouslySetInnerHTML={{ __html: data.text }} /></TabPane>
          <TabPane tabId='en'><span dangerouslySetInnerHTML={{ __html: data.latinText }} /></TabPane>
        </TabContent>
      </div>
    </React.Fragment>
  )
}
const renderBody = ({ loading, data }) => <DialogBody loading={loading} data={data} />
const dataSource = ({ helpKey }) => () => context.api.helpService.getHelp(helpKey)
export default {
  modalProps: { size: 'lg' },
  component: (props) =>
    <React.Fragment>
      <BasicHeader title='Common.HelpPreview' {...props} />
      <ModalBody>
        <DataLoader dataSource={dataSource(props)} render={renderBody} />
      </ModalBody>
      <CloseFooter {...props} />
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/dialogs/helpPreview.js